import * as GETTERS from '@/store/constants/getters.js';
import { isEqual } from 'commons/util/util.js';

export const getters = {
    [GETTERS.QUEUE_BY_UUID](state, getters) {
        return (uuid) => {
            const queue = state[uuid];

            if (!queue) {
                return undefined;
            }
            return {
                ...queue,
                active_users: queue.active_users.map(getters[GETTERS.USER_BY_UUID]),
                client: getters[GETTERS.CLIENT_BY_UUID](queue.client_uuid),
            };
        };
    },
    [GETTERS.QUEUE_BY_FILTER](state) {
        return (filters) => Object.values(state).find((queue) => isEqual(queue.filters.map(({ filter_uuid, ...filter }) => filter), filters)); // eslint-disable-line no-unused-vars
    },
    [GETTERS.CURRENT_QUEUE](state, getters) {
        return state[getters[GETTERS.CURRENT_QUEUE_UUID]];
    },
    [GETTERS.QUEUE_TAG_LIST](state, getters) {
        const queue = getters[GETTERS.CURRENT_QUEUE];
        if (queue) {
            return queue.tag_list;
        }
        return {};
    },
    [GETTERS.QUEUE_FILTER_TAG_LIST](state, getters) {
        const queue = getters[GETTERS.CURRENT_QUEUE];
        if (queue) {
            return queue.filter_tag_list;
        }
        return {};
    },
};
